<template>
  <div class="listPlayList__infoplaylist">
    <div class="listPlayList__infoplaylist__titlemovil">
      {{ playlist.name }}
    </div>
    <div class="movil-display">
      <div class="listPlayList__infoplaylist__img">
        <img :src="playlist.icon || 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_image@2x.png'" />
      </div>
      <div ref="infoContainer" class="listPlayList__infoplaylist__infocont">
        <div class="listPlayList__infoplaylist__infocont__contdata">
          <div class="listPlayList__infoplaylist__infocont__contdata__title" :style="dynamicWidth">
            {{ playlist.name }}
          </div>
          <div class="listPlayList__infoplaylist__infocont__contdata__description" :style="dynamicWidth">
            {{ playlist.description }}
          </div>
        </div>
        <div class="listPlayList__infoplaylist__infocont__contmenu">
          <div class="listPlayList__infoplaylist__infocont__contmenu__play" @click="emitPlaylist">
            Play
          </div>
          <div class="listPlayList__infoplaylist__infocont__contmenu__export" @click="openConfirmExport">
            Exportar<img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_export.png" />
          </div>
          <div class="listPlayList__infoplaylist__infocont__contmenu__infovideos">
            Videos contenidos:
            <span class="listPlayList__infoplaylist__infocont__contmenu__infovideos__bold">
              {{ playlist.plays.length }}
            </span>
          </div>
        </div>
      </div>
      <div class="listPlayList__infoplaylist__contenttabletmenupanel">
        <div class="listPlayList__infoplaylist__contenttabletmenupanel__sep"></div>
        <div class="listPlayList__infoplaylist__contenttabletmenupanel__content">
          <div class="listPlayList__infoplaylist__contenttabletmenupanel__content__infovideos">
            Videos contenidos:
            <span class="listPlayList__infoplaylist__contenttabletmenupanel__content__infovideos__bold">
              {{ playlist.plays.length }}
            </span>
          </div>
          <div class="listPlayList__infoplaylist__contenttabletmenupanel__content__sep"></div>
          <div class="listPlayList__infoplaylist__contenttabletmenupanel__content__contentbtns">
            <div
              class="listPlayList__infoplaylist__contenttabletmenupanel__content__contentbtns__play"
              @click="emitPlaylist"
            >
              Play
            </div>
            <div
              class="listPlayList__infoplaylist__contenttabletmenupanel__content__contentbtns__export"
              @click="openConfirmExport"
            >
              Exportar<img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_export.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="listPlayList__infoplaylist__contmenumovil">
      <div class="listPlayList__infoplaylist__contmenumovil__infovideos">
        Videos contenidos:
        <span class="listPlayList__infoplaylist__contmenumovil__infovideos__bold">
          {{ playlist.plays.length }}
        </span>
      </div>
      <div class="listPlayList__infoplaylist__contmenumovil__contbuttonsfunction">
        <div class="listPlayList__infoplaylist__contmenumovil__contbuttonsfunction__play" @click="emitPlaylist">
          Play
        </div>
        <div class="listPlayList__infoplaylist__contmenumovil__contbuttonsfunction__export" @click="openConfirmExport">
          Exportar<img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_export.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let resizeObserver = null;
export default {
  name: 'MyPlaylistItem',
  props: {
    playlist: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      infoContainerWidth: 0,
    };
  },
  computed: {
    dynamicWidth() {
      return { width: `${this.infoContainerWidth - 12}px` };
    },
  },
  methods: {
    openConfirmExport() {
      this.$emit('export', { num: this.playlist.plays.length, id: this.playlist.playlist_id });
    },
    emitPlaylist() {
      this.$emit('select');
    },
    setUpResizeObserver() {
      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(() => {
          this.infoContainerWidth = this.$refs.infoContainer.clientWidth;
        });

        resizeObserver.observe(this.$refs.infoContainer);
      } else {
        throw new Error('Resize observer not supported!');
      }
    },
  },
  mounted() {
    this.setUpResizeObserver();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  },
};
</script>

<style scoped lang="scss">
.movil-display {
  //display: inline-flex;
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-column-gap: 12px;
  width: 100%;

  @media screen and (max-width: 1176px) {
    grid-template-columns: min-content 1fr min-content;
  }

  & .listPlayList {
    &__infoplaylist {
      width: 100%;
      height: 146px;
      display: inline-flex;
      border-radius: 9px;
      border: solid 1px #e4eef4;
      padding: 10px;
      @media screen and (max-width: 1550px) {
        height: 234px;
      }
      @media screen and (max-width: 1420px) {
        display: inline-block;
      }
      @media screen and (max-width: 1176px) {
        //display: inline-flex;
        border-radius: 9px;
        border: solid 1px #e4eef4;
        height: 130px;
        padding: 5px;
        margin-bottom: 8px;
      }
      @media screen and (max-width: 690px) {
        display: inline-block;
        height: 224px;
      }

      &__contenttabletmenupanel {
        width: 160px;
        height: auto;
        display: none;
        @media screen and (max-width: 1176px) {
          display: inline-flex;
        }
        @media screen and (max-width: 690px) {
          display: none;
        }
        &__sep {
          width: 5px;
          height: 117px;
          border-right: 1px dashed #d1e0ea;
        }
        &__content {
          width: 100%;
          height: 117px;
          display: inline-block;
          &__infovideos {
            width: 100%;
            height: 60px;
            line-height: 60px;
            font-family: 'Avenir-Demi';
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.26px;
            text-align: center;
            color: #132839;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &__bold {
              font-size: 17px;
              font-family: 'Avenir-Bold';
            }
          }
          &__sep {
            width: 80%;
            margin-left: 10%;
            height: 1px;
            border-bottom: 1px dashed #d1e0ea;
          }
          &__contentbtns {
            display: inline-flex;
            justify-content: space-between;
            align-content: center;
            align-items: center;
            width: 100%;
            height: 58px;
            &__play {
              width: 92px;
              height: 30px;
              border-radius: 20px;
              background-color: #0f92ff;
              font-size: 14px;
              font-family: 'Avenir-Demi-Medium';
              font-weight: 500;
              line-height: 30px;
              font-stretch: normal;
              font-style: normal;
              letter-spacing: -0.28px;
              color: #fff;
              &:hover {
                background: #006ec9;
                cursor: pointer;
                opacity: 0.96;
              }
            }
            &__export {
              width: 129px;
              height: 30px;
              border-radius: 20px;
              background-color: #132839;
              font-size: 14px;
              margin-left: 2%;
              font-weight: 500;
              display: inline-flex;
              justify-content: center;
              font-family: 'Avenir-Demi-Medium';
              font-stretch: normal;
              font-style: normal;
              line-height: 30px;
              letter-spacing: -0.28px;
              color: #fff;
              img {
                width: 16px;
                height: 16px;
                margin-top: 4px;
                margin-left: 8px;
              }
              &:hover {
                background: #163c5a;
                cursor: pointer;
                opacity: 0.96;
              }
            }
          }
        }
      }
      &__contmenumovil {
        width: 100%;
        height: auto;
        display: none;
        justify-content: left;
        align-items: center;
        @media screen and (max-width: 1420px) {
          display: inline-block;
        }
        @media screen and (max-width: 1176px) {
          display: none;
        }
        @media screen and (max-width: 690px) {
          display: inline-block;
        }
        &__contbuttonsfunction {
          width: 100%;
          height: 33px;
          line-height: 26px;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          @media screen and (max-width: 600px) {
            justify-content: center;
          }
          &__play {
            width: 40%;
            height: 30px;
            border-radius: 30px;
            background-color: #0f92ff;
            font-size: 15px;
            font-family: 'Avenir-Demi-Medium';
            font-weight: 500;
            line-height: 26px;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.28px;
            color: #fff;
            &:hover {
              background: #006ec9;
              cursor: pointer;
              opacity: 0.96;
            }
          }
          &__export {
            width: 50%;
            height: 30px;
            display: inline-flex;
            border-radius: 30px;
            background-color: #132839;
            font-size: 15px;
            margin-left: 2%;
            font-weight: 500;
            display: inline-flex;
            justify-content: center;
            font-family: 'Avenir-Demi-Medium';
            font-stretch: normal;
            font-style: normal;
            line-height: 26px;
            letter-spacing: -0.28px;
            color: #fff;
            img {
              width: 16px;
              height: 16px;
              margin-top: 4px;
              margin-left: 8px;
            }
            &:hover {
              background: #163c5a;
              cursor: pointer;
              opacity: 0.96;
            }
          }
        }
        &__sep {
          width: 100%;
          height: 2px;
          margin-bottom: 0px;
          display: inline-block;
          border-bottom: 1px dashed #d1e0ea;
        }
        &__play {
          width: 74px;
          height: 26px;
          border-radius: 20px;
          background-color: #0f92ff;
          font-size: 14px;
          font-family: 'Avenir-Demi-Medium';
          font-weight: 500;
          line-height: 26px;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.28px;
          color: #fff;
          &:hover {
            background: #006ec9;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__export {
          width: 119px;
          height: 26px;
          border-radius: 20px;
          background-color: #132839;
          font-size: 14px;
          margin-left: 2%;
          font-weight: 500;
          display: inline-flex;
          justify-content: center;
          font-family: 'Avenir-Demi-Medium';
          font-stretch: normal;
          font-style: normal;
          line-height: 26px;
          letter-spacing: -0.28px;
          color: #fff;
          img {
            width: 16px;
            height: 16px;
            margin-top: 4px;
            margin-left: 8px;
          }
          &:hover {
            background: #163c5a;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__infovideos {
          width: 100%;
          height: 30px;
          line-height: 26px;
          margin-bottom: 5px;
          font-family: 'Avenir-Demi';
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          margin-top: 10px;
          font-style: normal;
          letter-spacing: -0.26px;
          text-align: center;
          border-top: 1px dashed #d1e0ea;
          border-bottom: 1px dashed #d1e0ea;
          color: #132839;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &__bold {
            font-size: 17px;
            font-family: 'Avenir-Bold';
          }
        }
      }
      &__titlemovil {
        width: 100%;
        height: 28px;
        padding-top: 2px;
        display: none;
        @media screen and (max-width: 1420px) {
          display: inline-block;
        }
        @media screen and (max-width: 1176px) {
          display: none;
        }
        @media screen and (max-width: 690px) {
          display: inline-block;
          width: calc(100vw - 60px);
        }
        font-size: 23px;
        font-family: 'Avenir-Demi';
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 24px;
        letter-spacing: -0.52px;
        text-align: left;
        color: #132839;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &__img {
        width: 117px;
        height: 100%;

        & img {
          width: 117px;
        }
        @media screen and (max-width: 1420px) {
          width: 94px;
          & img {
            width: 94px;
          }
        }
        @media screen and (max-width: 1176px) {
          width: 117px;

          & img {
            width: 117px;
          }
        }
        @media screen and (max-width: 690px) {
          width: 94px;

          & img {
            width: 94px;
          }
        }
      }
      &__infocont {
        width: 100%;
        height: 100%;
        //@media screen and (max-width: 1035px) {
        //  width: 750px;
        //}
        //@media screen and (max-width: 985px) {
        //  width: 700px;
        //}
        //@media screen and (max-width: 935px) {
        //  width: 650px;
        //}
        //@media screen and (max-width: 885px) {
        //  width: 600px;
        //}
        //@media screen and (max-width: 835px) {
        //  width: 550px;
        //}
        //@media screen and (max-width: 785px) {
        //  width: 500px;
        //}
        //@media screen and (max-width: 550px) {
        //  width: 450px;
        //}
        //@media screen and (max-width: 500px) {
        //  width: 400px;
        //}
        //@media screen and (max-width: 450px) {
        //  width: 350px;
        //}
        //@media screen and (max-width: 400px) {
        //  width: 300px;
        //}
        //@media screen and (max-width: 350px) {
        //  width: 250px;
        //}
        &__contdata {
          width: 100%;
          height: 70px;
          margin-top: 3px;
          display: inline-block;
          @media screen and (max-width: 1420px) {
            height: 98px;
          }
          @media screen and (max-width: 1176px) {
            margin-top: 0px;
            height: 135px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
          @media screen and (max-width: 690px) {
            height: 98px;
            margin-top: 3px;
          }
          &__title {
            width: 100%;
            height: 28px;
            padding-top: 2px;
            margin-top: 5px;
            @media screen and (max-width: 1420px) {
              display: none;
            }
            @media screen and (max-width: 1176px) {
              display: inline-block;
            }
            @media screen and (max-width: 690px) {
              display: none;
            }
            font-size: 26px;
            font-family: 'Avenir-Demi';
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.85;
            letter-spacing: -0.52px;
            text-align: left;
            color: #132839;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &__description {
            height: 34px;
            margin-top: 9px;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.31;
            font-family: 'Avenir-Regular';
            letter-spacing: -0.26px;
            text-align: left;
            color: #132839;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            @media screen and (max-width: 1420px) {
              -webkit-line-clamp: 4;
              height: 82px;
              width: 340px;
            }
            @media screen and (max-width: 1345px) {
              width: 1040px;
            }
            @media screen and (max-width: 1320px) {
              width: 1015px;
            }
            @media screen and (max-width: 1300px) {
              width: 995px;
            }
            @media screen and (max-width: 1275px) {
              width: 970px;
            }
            @media screen and (max-width: 1250px) {
              width: 945px;
            }
            @media screen and (max-width: 1225px) {
              width: 920px;
            }
            @media screen and (max-width: 1200px) {
              width: 895px;
            }
            @media screen and (max-width: 1175px) {
              width: 100%;
            }

            @media screen and (max-width: 690px) {
              -webkit-line-clamp: 5;
              height: 82px;
              padding-right: 10px;
            }
          }
        }
        &__contmenu {
          width: 100%;
          margin-top: 2px;
          height: 49px;
          display: inline-flex;
          justify-content: left;
          align-items: center;
          @media screen and (max-width: 1420px) {
            display: none;
          }
          &__play {
            width: 74px;
            height: 26px;
            border-radius: 20px;
            background-color: #0f92ff;
            font-size: 14px;
            font-family: 'Avenir-Demi-Medium';
            font-weight: 500;
            line-height: 26px;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.28px;
            color: #fff;
            &:hover {
              background: #006ec9;
              cursor: pointer;
              opacity: 0.96;
            }
          }
          &__export {
            width: 119px;
            height: 26px;
            border-radius: 20px;
            background-color: #132839;
            font-size: 14px;
            margin-left: 2%;
            font-weight: 500;
            display: inline-flex;
            justify-content: center;
            font-family: 'Avenir-Demi-Medium';
            font-stretch: normal;
            font-style: normal;
            line-height: 26px;
            letter-spacing: -0.28px;
            color: #fff;
            img {
              width: 16px;
              height: 16px;
              margin-top: 4px;
              margin-left: 8px;
            }
            &:hover {
              background: #163c5a;
              cursor: pointer;
              opacity: 0.96;
            }
          }
          &__infovideos {
            height: 26px;
            border-radius: 20px;
            line-height: 26px;
            font-family: 'Avenir-Demi';
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.26px;
            text-align: left;
            color: #132839;
            margin-left: 2%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &__bold {
              font-size: 17px;
              font-family: 'Avenir-Bold';
            }
          }
        }
      }
    }
  }
}
.listPlayList {
  &__infoplaylist {
    width: 100%;
    height: 146px;
    display: inline-flex;
    border-radius: 9px;
    border: solid 1px #e4eef4;
    padding: 10px;
    @media screen and (max-width: 1550px) {
      height: 234px;
    }
    @media screen and (max-width: 1420px) {
      display: inline-block;
    }
    @media screen and (max-width: 1176px) {
      display: inline-flex;
      border-radius: 9px;
      border: solid 1px #e4eef4;
      height: 130px;
      padding: 5px;
      margin-bottom: 8px;
    }
    @media screen and (max-width: 690px) {
      display: inline-block;
      height: 224px;
    }

    &__contenttabletmenupanel {
      width: 35%;
      height: auto;
      display: none;
      @media screen and (max-width: 1176px) {
        display: inline-flex;
      }
      @media screen and (max-width: 900px) {
        width: 45%;
      }
      @media screen and (max-width: 810px) {
        width: 50%;
      }
      @media screen and (max-width: 768px) {
        width: 48%;
      }
      @media screen and (max-width: 690px) {
        display: none;
      }
      &__sep {
        width: 5px;
        height: 117px;
        border-right: 1px dashed #d1e0ea;
      }
      &__content {
        width: 100%;
        height: 117px;
        display: inline-block;
        &__infovideos {
          width: 100%;
          height: 60px;
          line-height: 60px;
          font-family: 'Avenir-Demi';
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.26px;
          text-align: center;
          color: #132839;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &__bold {
            font-size: 17px;
            font-family: 'Avenir-Bold';
          }
        }
        &__sep {
          width: 80%;
          margin-left: 10%;
          height: 1px;
          border-bottom: 1px dashed #d1e0ea;
        }
        &__contentbtns {
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          width: 100%;
          height: 58px;
          &__play {
            width: 92px;
            height: 30px;
            border-radius: 20px;
            background-color: #0f92ff;
            font-size: 14px;
            font-family: 'Avenir-Demi-Medium';
            font-weight: 500;
            line-height: 30px;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.28px;
            color: #fff;
            &:hover {
              background: #006ec9;
              cursor: pointer;
              opacity: 0.96;
            }
          }
          &__export {
            width: 129px;
            height: 30px;
            border-radius: 20px;
            background-color: #132839;
            font-size: 14px;
            font-weight: 500;
            display: inline-flex;
            justify-content: center;
            font-family: 'Avenir-Demi-Medium';
            font-stretch: normal;
            font-style: normal;
            line-height: 30px;
            letter-spacing: -0.28px;
            color: #fff;
            img {
              width: 16px;
              height: 16px;
              margin-top: 4px;
              margin-left: 8px;
            }
            &:hover {
              background: #163c5a;
              cursor: pointer;
              opacity: 0.96;
            }
          }
        }
      }
    }
    &__contmenumovil {
      width: 100%;
      height: auto;
      display: none;
      justify-content: left;
      align-items: center;
      @media screen and (max-width: 1420px) {
        display: inline-block;
      }
      @media screen and (max-width: 1176px) {
        display: none;
      }
      @media screen and (max-width: 690px) {
        display: inline-block;
      }
      &__contbuttonsfunction {
        width: 100%;
        height: 33px;
        line-height: 26px;
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 600px) {
          justify-content: center;
        }
        &__play {
          width: 40%;
          height: 30px;
          border-radius: 30px;
          background-color: #0f92ff;
          font-size: 15px;
          font-family: 'Avenir-Demi-Medium';
          font-weight: 500;
          line-height: 26px;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.28px;
          color: #fff;
          &:hover {
            background: #006ec9;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__export {
          width: 50%;
          height: 30px;
          display: inline-flex;
          border-radius: 30px;
          background-color: #132839;
          font-size: 15px;
          margin-left: 2%;
          font-weight: 500;
          display: inline-flex;
          justify-content: center;
          font-family: 'Avenir-Demi-Medium';
          font-stretch: normal;
          font-style: normal;
          line-height: 26px;
          letter-spacing: -0.28px;
          color: #fff;
          img {
            width: 16px;
            height: 16px;
            margin-top: 4px;
            margin-left: 8px;
          }
          &:hover {
            background: #163c5a;
            cursor: pointer;
            opacity: 0.96;
          }
        }
      }
      &__sep {
        width: 100%;
        height: 2px;
        margin-bottom: 0px;
        display: inline-block;
        border-bottom: 1px dashed #d1e0ea;
      }
      &__play {
        width: 74px;
        height: 26px;
        border-radius: 20px;
        background-color: #0f92ff;
        font-size: 14px;
        font-family: 'Avenir-Demi-Medium';
        font-weight: 500;
        line-height: 26px;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.28px;
        color: #fff;
        &:hover {
          background: #006ec9;
          cursor: pointer;
          opacity: 0.96;
        }
      }
      &__export {
        width: 119px;
        height: 26px;
        border-radius: 20px;
        background-color: #132839;
        font-size: 14px;
        margin-left: 2%;
        font-weight: 500;
        display: inline-flex;
        justify-content: center;
        font-family: 'Avenir-Demi-Medium';
        font-stretch: normal;
        font-style: normal;
        line-height: 26px;
        letter-spacing: -0.28px;
        color: #fff;
        img {
          width: 16px;
          height: 16px;
          margin-top: 4px;
          margin-left: 8px;
        }
        &:hover {
          background: #163c5a;
          cursor: pointer;
          opacity: 0.96;
        }
      }
      &__infovideos {
        width: 100%;
        height: 30px;
        line-height: 26px;
        margin-bottom: 5px;
        font-family: 'Avenir-Demi';
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        margin-top: 10px;
        font-style: normal;
        letter-spacing: -0.26px;
        text-align: center;
        border-top: 1px dashed #d1e0ea;
        border-bottom: 1px dashed #d1e0ea;
        color: #132839;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &__bold {
          font-size: 17px;
          font-family: 'Avenir-Bold';
        }
      }
    }
    &__titlemovil {
      width: 100%;
      height: 28px;
      padding-top: 2px;
      display: none;
      @media screen and (max-width: 1420px) {
        display: inline-block;
      }
      @media screen and (max-width: 1176px) {
        display: none;
      }
      @media screen and (max-width: 690px) {
        display: inline-block;
        width: calc(100vw - 60px);
      }
      font-size: 23px;
      font-family: 'Avenir-Demi';
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 24px;
      letter-spacing: -0.52px;
      text-align: left;
      color: #132839;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &__img {
      width: 28%;
      max-width: 126px;
      height: 100%;
      @media screen and (max-width: 1420px) {
        width: 100%;
        max-width: 94px;
      }
      @media screen and (max-width: 1176px) {
        width: 100%;
        max-width: 117.7px;
      }
      @media screen and (max-width: 690px) {
        width: 100%;
        max-width: 94px;
      }
      img {
        width: 100%;
        max-width: 126px;
        @media screen and (max-width: 1420px) {
          width: 100%;
          max-width: 94px;
        }
        @media screen and (max-width: 1176px) {
          width: 100%;
          max-width: 117.7px;
        }
      }
    }
    &__infocont {
      width: 78%;
      display: inline-block;
      height: 100%;
      margin-left: 0;
      @media screen and (max-width: 1176px) {
        width: 800px;
      }
      @media screen and (max-width: 1035px) {
        width: 750px;
      }
      @media screen and (max-width: 985px) {
        width: 700px;
      }
      @media screen and (max-width: 935px) {
        width: 650px;
      }
      @media screen and (max-width: 885px) {
        width: 600px;
      }
      @media screen and (max-width: 835px) {
        width: 550px;
      }
      @media screen and (max-width: 785px) {
        width: 500px;
      }
      @media screen and (max-width: 550px) {
        width: 450px;
      }
      @media screen and (max-width: 500px) {
        width: 400px;
      }
      @media screen and (max-width: 450px) {
        width: 350px;
      }
      @media screen and (max-width: 400px) {
        width: 300px;
      }
      @media screen and (max-width: 350px) {
        width: 250px;
      }
      &__contdata {
        width: 100%;
        height: 70px;
        margin-top: 3px;
        display: inline-block;
        @media screen and (max-width: 1420px) {
          height: 98px;
        }
        @media screen and (max-width: 1176px) {
          margin-top: 0px;
          height: 135px;
        }
        @media screen and (max-width: 690px) {
          height: 98px;
          margin-top: 3px;
        }
        &__title {
          width: 100%;
          height: 28px;
          padding-top: 2px;
          margin-top: 5px;
          @media screen and (max-width: 1420px) {
            display: none;
          }
          @media screen and (max-width: 1176px) {
            display: inline-block;
          }
          @media screen and (max-width: 690px) {
            display: none;
          }
          font-size: 26px;
          font-family: 'Avenir-Demi';
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.85;
          letter-spacing: -0.52px;
          text-align: left;
          color: #132839;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &__description {
          width: 100%;
          height: 34px;
          margin-top: 9px;
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.31;
          font-family: 'Avenir-Regular';
          letter-spacing: -0.26px;
          text-align: left;
          color: #132839;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          @media screen and (max-width: 1420px) {
            -webkit-line-clamp: 4;
            height: 82px;
            width: 340px;
          }
          @media screen and (max-width: 1345px) {
            width: 1040px;
          }
          @media screen and (max-width: 1320px) {
            width: 1015px;
          }
          @media screen and (max-width: 1300px) {
            width: 995px;
          }
          @media screen and (max-width: 1275px) {
            width: 970px;
          }
          @media screen and (max-width: 1250px) {
            width: 945px;
          }
          @media screen and (max-width: 1225px) {
            width: 920px;
          }
          @media screen and (max-width: 1200px) {
            width: 895px;
          }
          @media screen and (max-width: 1175px) {
            width: 100%;
          }

          @media screen and (max-width: 690px) {
            -webkit-line-clamp: 5;
            height: 82px;
            padding-right: 10px;
          }
        }
      }
      &__contmenu {
        width: 100%;
        margin-top: 2px;
        height: 49px;
        display: inline-flex;
        justify-content: left;
        align-items: center;
        @media screen and (max-width: 1420px) {
          display: none;
        }
        &__play {
          width: 74px;
          height: 26px;
          border-radius: 20px;
          background-color: #0f92ff;
          font-size: 14px;
          font-family: 'Avenir-Demi-Medium';
          font-weight: 500;
          line-height: 26px;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.28px;
          color: #fff;
          &:hover {
            background: #006ec9;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__export {
          width: 119px;
          height: 26px;
          border-radius: 20px;
          background-color: #132839;
          font-size: 14px;
          margin-left: 2%;
          font-weight: 500;
          display: inline-flex;
          justify-content: center;
          font-family: 'Avenir-Demi-Medium';
          font-stretch: normal;
          font-style: normal;
          line-height: 26px;
          letter-spacing: -0.28px;
          color: #fff;
          img {
            width: 16px;
            height: 16px;
            margin-top: 4px;
            margin-left: 8px;
          }
          &:hover {
            background: #163c5a;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__infovideos {
          height: 26px;
          border-radius: 20px;
          line-height: 26px;
          font-family: 'Avenir-Demi';
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.26px;
          text-align: left;
          color: #132839;
          margin-left: 2%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &__bold {
            font-size: 17px;
            font-family: 'Avenir-Bold';
          }
        }
      }
    }
  }
}
</style>
